import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const Navbar = () => {
  const { pathname, search } = useLocation();
  const [open, setOpen] = useState(false);

  const isHomeStoryActive =
    pathname === "/" && new URLSearchParams(search).get("view") !== "intro";

  const navLinks = [
    { to: "/?view=story", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/experience", label: "Experience" },
    { to: "/contact", label: "Contact" },
    { to: "/certifications", label: "Certifications" },
  ];

  return (
    <nav className="sticky top-0 z-50 w-full px-4 py-4 md:px-8">
      <div className="page-panel mx-auto flex max-w-6xl items-center justify-between rounded-[1.6rem] px-5 py-3 md:px-7">
        <Link to="/?view=story" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[linear-gradient(135deg,#0d7a55,#0b4f39)] text-sm font-semibold text-white shadow-[0_10px_25px_rgba(13,122,85,0.3)]">
            AE
          </span>
          <div>
            <p className="text-[0.65rem] font-semibold uppercase tracking-[0.28em] text-[color:var(--accent-strong)]">
              Portfolio
            </p>
            <h1 className="text-base font-bold text-[color:var(--text-strong)] md:text-lg">
              Amr El Shimy
            </h1>
          </div>
        </Link>

        <div className="hidden gap-2 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`rounded-full px-4 py-2 text-sm font-medium transition ${
                pathname === link.to ||
                (link.to.startsWith("/?view=story") && isHomeStoryActive)
                  ? "bg-[color:var(--text-strong)] text-[color:var(--surface-strong)] shadow-[0_10px_25px_rgba(17,35,24,0.22)]"
                  : "text-[color:var(--text-soft)] hover:bg-white/10 hover:text-[color:var(--text-strong)]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          className="rounded-xl border border-[color:var(--surface-border)] bg-[color:var(--surface-soft)] p-2 text-[color:var(--text-strong)] shadow-sm md:hidden"
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden px-4 pt-4"
          >
            <div className="page-panel flex flex-col gap-2 rounded-[1.4rem] p-3 pb-2">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setOpen(false)}
                  className={`rounded-xl px-3 py-2 text-sm font-medium transition ${
                    pathname === link.to ||
                    (link.to.startsWith("/?view=story") && isHomeStoryActive)
                      ? "bg-[color:var(--text-strong)] text-[color:var(--surface-strong)]"
                      : "text-[color:var(--text-soft)] hover:bg-white/10 hover:text-[color:var(--text-strong)]"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
